import React from "react";
import styled from "styled-components";

import { Device } from "utils/device";
import { CM } from "components/Typography";

const QuoteContent2025 = (props) => {
  return (
    <S.Section {...props}>
      <S.Paragraph {...props}>
        <S.BoldWrap>“</S.BoldWrap>The panel talks were{" "}
        <S.BoldWrap>brilliant </S.BoldWrap>
        and the range of speakers was <S.BoldWrap>impressive. </S.BoldWrap>I
        enjoyed networking and meeting lots of new people.{" "}
        <S.BoldWrap>The buzz was incredible.”</S.BoldWrap>
      </S.Paragraph>
      <CM>
        <b>Attendee |</b> <i>Step Forward London Summit 2024</i>
      </CM>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  width: 100%;
  padding: 10%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  background-image: url(/images/step-forward-2025/light-blue-marble-background.png);
  background-repeat: no-repeat;
  background-size: cover;

  @supports not (-webkit-touch-callout: none) {
    background-attachment: fixed;
  }

  @media (min-width: ${Device.tablet}) {
    padding: 5% 20% 5% 10%;
  }
`;

S.Paragraph = styled.p`
  font-size: 2rem;
  line-height: 2.5rem;

  @media (min-width: ${Device.mobile}) {
    font-size: 2.5rem;
    line-height: 3.4rem;
  }
`;

S.BoldWrap = styled.span`
  font-weight: 700;
`;

export default QuoteContent2025;
